export const PaymentMethodsEnum = {
    Bank: { label: 'Bank', value: 'Bank' },
    CreditCard: { label: 'Credit Card', value: 'CreditCard' },
    Stripe: { label: 'Stripe', value: 'Stripe' },
    Cheque: { label: 'Cheque', value: 'Cheque' },
    Cash: { label: 'Cash', value: 'Cash' },
  };